import { createContext, useEffect, useState } from 'react'
import { auth } from '../config'
import { onAuthStateChanged } from 'firebase/auth'

export const AuthContext = createContext()

export const AuthContextProvider = ({ children }) => {
  const [curUser, setCurUser] = useState({})

  useEffect(() => {
    const notSubmit = onAuthStateChanged(auth, (user) => {
      setCurUser(user)
    })

    return () => {
      notSubmit()
    }
  }, [])

  return (
    <AuthContext.Provider value={{ curUser }}>{children}</AuthContext.Provider>
  )
}
